import { AvailableProducts } from 'app/constants/Products';

interface SegmentEventMapping {
  viewEvent: string;
  completionEvent: string;
  productName?: string;
  isOnboarding?: boolean;
}

export const SEGMENT_KING_EVENTS = {
  VIEWED_STATE_SELECTION: 'Viewed State Selection Page',
  VIEWED_NAME_ENTRY: 'Viewed Name Entry Page',
  VIEWED_ACCOUNT_CREATION: 'Viewed Account Creation Page',
  VIEWED_GETTING_STARTED: 'Viewed Getting Started Page',
  VIEWED_FERTILITY_PLAN: 'Viewed Fertility Plan Page',
  VIEWED_TESTICULAR_RISK: 'Viewed Testicular Risk Page',
  VIEWED_MEDICAL_DEPENDENCE: 'Viewed Medical Dependence Page',
  VIEWED_LIBIDO_PREFERENCE: 'Viewed Libido Preference Page',
  VIEWED_ORAL_TRT_WARNING: 'Viewed Oral TRT Warning Page',
  VIEWED_TOPICAL_WARNING: 'Viewed Topical Warning Page',
  VIEWED_INJECTABLE_WARNING: 'Viewed Injectable Warning Page',
  VIEWED_TREATMENT_PREFERENCE: 'Viewed Treatment Preference Page',
  VIEWED_PREVIOUS_TESTOSTERONE_TREATMENT: 'Viewed Have You Ever Received Testosterone Treatment Page',
  COMPLETED_STATE_SELECTION: 'Completed State Selection Page',
  COMPLETED_FERTILITY_PLAN: 'Completed Fertility Plan Page',
  COMPLETED_TESTICULAR_RISK: 'Completed Testicular Risk Page',
  COMPLETED_MEDICAL_DEPENDENCE: 'Completed Medical Dependence Page',
  COMPLETED_LIBIDO_PREFERENCE: 'Completed Libido Preference Page',
  COMPLETED_ORAL_TRT_WARNING: 'Completed Oral TRT Warning Page',
  COMPLETED_TOPICAL_WARNING: 'Completed Topical Warning Page',
  COMPLETED_INJECTABLE_WARNING: 'Completed Injectable Warning Page',
  COMPLETED_TREATMENT_PREFERENCE: 'Completed Treatment Preference Page',
  COMPLETED_PREVIOUS_TESTOSTERONE_TREATMENT: 'Completed Have You Ever Received Testosterone Treatment Page',
};

export const SEGMENT_EVENTS_STEP_MAPPING: Record<string, SegmentEventMapping> = {
  fertility: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_FERTILITY_PLAN,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_FERTILITY_PLAN,
  },
  testicular_health: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_TESTICULAR_RISK,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_TESTICULAR_RISK,
  },
  medication_dependence: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_MEDICAL_DEPENDENCE,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_MEDICAL_DEPENDENCE,
  },
  libido_preference: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_LIBIDO_PREFERENCE,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_LIBIDO_PREFERENCE,
  },
  oral_testosterone_fat_intake: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_ORAL_TRT_WARNING,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_ORAL_TRT_WARNING,
  },
  topical_testosterone_application: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_TOPICAL_WARNING,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_TOPICAL_WARNING,
  },
  injectable_testosterone_willingness: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_INJECTABLE_WARNING,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_INJECTABLE_WARNING,
  },
  treatment_preference: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_TREATMENT_PREFERENCE,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_TREATMENT_PREFERENCE,
  },
  previous_testosterone_treatment: {
    viewEvent: SEGMENT_KING_EVENTS.VIEWED_PREVIOUS_TESTOSTERONE_TREATMENT,
    completionEvent: SEGMENT_KING_EVENTS.COMPLETED_PREVIOUS_TESTOSTERONE_TREATMENT,
    productName: AvailableProducts.King,
  },
  lover_intro: {
    viewEvent: 'Viewed Blood Flow Introduction Page',
    completionEvent: 'Completed Blood Flow Introduction Page',
  },
  lover_allergies: {
    viewEvent: 'Viewed Blood Flow Allergies Page',
    completionEvent: 'Completed Blood Flow Allergies Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  surgeries: {
    viewEvent: 'Viewed Past Surgeries Page',
    completionEvent: 'Completed Past Surgeries Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  cardiovascular_symptoms: {
    viewEvent: 'Viewed Blood Flow Diseases Page',
    completionEvent: 'Completed Blood Flow Diseases Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  diagnoses: {
    viewEvent: 'Viewed Blood Flow Diagnosis Page',
    completionEvent: 'Completed Blood Flow Diagnosis Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  lover_health: {
    viewEvent: 'Viewed Fainting Page',
    completionEvent: 'Completed Fainting Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  blood_pressure_reading: {
    viewEvent: 'Viewed Blood Pressure Reading Page',
    completionEvent: 'Completed Blood Pressure Reading Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  drugs: {
    viewEvent: 'Viewed Smoking or Drugs Page',
    completionEvent: 'Completed Smoking or Drugs Page',
    productName: AvailableProducts.Lover,
    isOnboarding: true,
  },
  magician_intro: {
    viewEvent: 'Viewed Weight Loss Introduction Page',
    completionEvent: 'Completed Weight Loss Introduction Page',
  },
  magician_current_medications: {
    viewEvent: 'Viewed Weight Loss Medications Page',
    completionEvent: 'Completed Weight Loss Medications Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  magician_current_medications_3: {
    viewEvent: 'Viewed Conditions Page',
    completionEvent: 'Completed Conditions Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  bodyfat: {
    viewEvent: 'Viewed Body Fat Page',
    completionEvent: 'Completed Body Fat Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  height: {
    viewEvent: 'Viewed Height Page',
    completionEvent: 'Completed Height Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  weight: {
    viewEvent: 'Viewed Weight Page',
    completionEvent: 'Completed Weight Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  goal_weight: {
    viewEvent: 'Viewed Goal Weight Page',
    completionEvent: 'Completed Goal Weight Page',
    productName: AvailableProducts.Magician,
    isOnboarding: true,
  },
  warrior_medication_preference: {
    viewEvent: 'Viewed Oral or Topical Page',
    completionEvent: 'Completed Oral or Topical Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
  scalp_q: {
    viewEvent: 'Viewed Scalp Symptoms Page',
    completionEvent: 'Completed Scalp Symptoms Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
  minoxidil_q: {
    viewEvent: 'Viewed Minoxidil Page',
    completionEvent: 'Completed Minoxidil Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
  warrior_diagnoses: {
    viewEvent: 'Viewed Hair Growth Conditions Page',
    completionEvent: 'Completed Hair Growth Conditions Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
  warrior_current_medications: {
    viewEvent: 'Viewed Hair Growth Medications Yes or No Page',
    completionEvent: 'Completed Hair Growth Medications Yes or No Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
  warrior_allergies: {
    viewEvent: 'Viewed Hair Growth Allergies Page',
    completionEvent: 'Completed Hair Growth Allergies Page',
    productName: AvailableProducts.Warrior,
    isOnboarding: true,
  },
};

export const SEGMENT_LOVER_EVENTS = {
  VIEWED_SEX_PAGE: 'Viewed Sex Page',
  VIEWED_ERECTION_PAGE: 'Viewed Erection Page',
  VIEWED_ERECTILE_DYSFUNCTION_PAGE: 'Viewed Erectile Dysfunction Page',
  VIEWED_ERECTILE_DYSFUNCTION_START_PAGE: 'Viewed Erectile Dysfunction Start Page',

  COMPLETED_SEX_PAGE: 'Completed Sex Page',
  COMPLETED_ERECTION_PAGE: 'Completed Erection Page',
  COMPLETED_ERECTILE_DYSFUNCTION_PAGE: 'Completed Erectile Dysfunction Page',
  COMPLETED_ERECTILE_DYSFUNCTION_START_PAGE: 'Completed Erectile Dysfunction Start Page',
};

export const SEGMENT_LOVER_EVENTS_STEP_MAPPING = {
  sex: {
    viewEvent: SEGMENT_LOVER_EVENTS.VIEWED_SEX_PAGE,
    completionEvent: SEGMENT_LOVER_EVENTS.COMPLETED_SEX_PAGE,
  },
  erection: {
    viewEvent: SEGMENT_LOVER_EVENTS.VIEWED_ERECTION_PAGE,
    completionEvent: SEGMENT_LOVER_EVENTS.COMPLETED_ERECTION_PAGE,
  },
  ed_scenario: {
    viewEvent: SEGMENT_LOVER_EVENTS.VIEWED_ERECTILE_DYSFUNCTION_PAGE,
    completionEvent: SEGMENT_LOVER_EVENTS.COMPLETED_ERECTILE_DYSFUNCTION_PAGE,
  },
  ed_start: {
    viewEvent: SEGMENT_LOVER_EVENTS.VIEWED_ERECTILE_DYSFUNCTION_START_PAGE,
    completionEvent: SEGMENT_LOVER_EVENTS.COMPLETED_ERECTILE_DYSFUNCTION_START_PAGE,
  },
};

export const SEGMENT_WARRIOR_EVENTS = {
  VIEWED_HAIR_DESCRIPTION_PAGE: 'Viewed Hair Description Page',
  COMPLETED_HAIR_DESCRIPTION_PAGE: 'Completed Hair Description Page',
};
